<template>
    <div>
        <Navbar />
        <div class="slider">
            <div class="item">
                <h1>سبد خرید</h1>
            </div>
        </div>
        <CartItems v-if="step==1" @bankPaymentType="setBankPaymentType" />
        <CartInfo v-if="step==2" @step="setStep" />
        <Footer />
    </div>
</template>
<script>
    import store from "@/store";
    import Navbar from "./share/Navbar";
    import Footer from "./share/Footer";
    import CartItems from "./cart/CartItems";
    import CartInfo from "./cart/CartInfo";

    export default {
        components: {
            Navbar,
            Footer,
            CartItems,
            CartInfo
        },

        data()
        {
            return {
                step: 1
            };
        },

        beforeMount()
        {
        },

        methods: {

            setBankPaymentType(value)
            {
                store.cart.bankPaymentTypeId = value
                this.step = 2;
            },

            setStep(value)
            {
                this.step = value;
            }
        }
    };
</script>
<style scoped>
    .slider,
    .slider .item {
        width: 100%;
        float: left;
        height: 150px;
    }

    .slider {
        padding: 0 !important;
        margin-bottom: 0;
    }

        .slider .item {
            background: #292929;
        }

        .slider h1 {
            position: relative;
            top: 80px;
            text-align: center;
            color: #fff;
            font-size: 28px;
        }
</style>
